module.exports = __webpack_public_path__ + "static/media/default_file.e8e406f5.svg";